"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TwoColumnSlide = _interopRequireDefault(require("./TwoColumnSlide"));
var _CtaBlock = _interopRequireDefault(require("../../block/CtaBlock"));
require("./../../../scss/carousels/slide-layouts/NetworkCalloutSlide.module.scss");
function NetworkCalloutSlide(_ref) {
  let {
    network
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("network-callout-slide", null, /*#__PURE__*/_react.default.createElement(_TwoColumnSlide.default, {
    columnOneContent: /*#__PURE__*/_react.default.createElement(_CtaBlock.default, {
      title: network.name,
      content: network.tagline,
      titleImageUrl: network.images.logo.url,
      type: 'external-link',
      btnGradientStartColor: "#191919",
      btnGradientEndColor: "#565656"
    }),
    columnTwoContent: "<img src=\"".concat(network.images.callout.url, "\" />")
  }));
}
var _default = exports.default = NetworkCalloutSlide;